// Helmet template fit at the in-game area-normalized scale, ticket knight-scale-color-0930 (2026-09-30).
// Values are helmet world size relative to idle=100; defeat is intentionally excluded.
export const KNIGHT_HELMET_PERCENT: Readonly<Record<string, number>> = {
  walk_passing: 97, walk_reach: 96, turn: 91,
  lanceThrust_coilStart: 89, lanceThrust_windup: 91, lanceThrust_strike: 94,
  lanceThrust_full: 93, lanceThrust_overextend: 90, lanceThrust_recover: 93,
  lanceThrust_linkWindup: 92, lanceDouble_gap: 94,
  lanceSweep_windup: 97, lanceSweep_contact: 87,
  leap_swing: 94, scrape_stop: 89, charge_run1: 87, charge_run2: 84,
  lanceButt_windup: 99, lanceButt_slam: 84,
  knightExecution_windup: 92, knightExecution_impale: 93,
  staggered: 98, lanceSweep_linkWindup: 86, lanceSweep_holdOn: 84,
  // 2026-10-01 柄の押し返し (票 knight-shove-art-1001): 兜の高さ/√面積 を lanceSweep_contact (87) と比べて換算。
  lanceShove_windup: 93, lanceShove_contact: 85,
}

export function knightHelmetScaleFactor(key: string, enabled: boolean): number {
  return enabled ? 100 / (KNIGHT_HELMET_PERCENT[key] ?? 100) : 1
}

// Production uses helmet fit; DEV can compare the previously shipped sizes.
let helmetScale = true
export function knightHelmetScaleEnabled(): boolean { return helmetScale }
export function setKnightHelmetScale(enabled: boolean): void { helmetScale = enabled }
if (import.meta.env.DEV && typeof window !== 'undefined') {
  helmetScale = new URLSearchParams(window.location.search).get('knightScale') !== 'old'
}
